import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { COMPANY } from '../../constants/company';

/**
 * Shared shell for all legal / policy pages so they look consistent and
 * inherit the same site chrome (header, footer, dhs theme).
 */
export const LegalShell = ({ eyebrow, title, updated, children }) => {
  const effective = updated || new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
  return (
    <div className="bg-dhs min-h-screen text-primary-dhs">
      <Header />
      <main className="pt-12 md:pt-16 pb-24">
        <div className="max-w-4xl mx-auto px-5">
          <nav className="text-xs text-[#1F0068]/60 mb-3" data-testid="legal-breadcrumb">
            <Link to="/" className="hover:text-[#1F0068]">Home</Link> <span className="mx-1">/</span> Legal &amp; Policies <span className="mx-1">/</span> <span className="font-semibold text-[#1F0068]">{title}</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#FF5C39]">{eyebrow}</div>
          <h1 className="mt-2 text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-[1.05]">{title}</h1>
          <div className="mt-3 text-sm text-[#1F0068]/60">Last updated: {effective} · Applies across all of {COMPANY.name}’s services in the UK.</div>

          <div className="mt-10 bg-white rounded-3xl p-6 md:p-10 border border-[#1F0068]/5 space-y-6 legal-body text-[15px] leading-relaxed text-[#1F0068]/85">
            {children}
          </div>

          <div className="mt-8 bg-[#FFF6EB] rounded-2xl p-5 text-sm text-[#1F0068]/80">
            Any questions about this policy? Please contact our team on <b>{COMPANY.phoneShort}</b> or <b>{COMPANY.email}</b>. Our registered office is {COMPANY.registeredOffice.full}, and we are registered in England &amp; Wales, company number {COMPANY.companyNumber}. We are committed to providing transparent, professional and customer-focused home maintenance services in accordance with applicable UK laws and consumer protection legislation.
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const Section = ({ n, title, children }) => (
  <section>
    <h2 className="text-xl md:text-2xl font-bold text-[#1F0068]">{n}. {title}</h2>
    <div className="mt-3 space-y-3">{children}</div>
  </section>
);

export const List = ({ items }) => (
  <ul className="list-disc ml-5 space-y-1.5">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);

export default LegalShell;
